<template>
  <div>
    <b-row class="row-padding">
      <b-col sm="4">
        <InputQuantity
          ref="pICMS"
          id="pICMS"
          label="% ICMS"
          inputClass="form-control input"
          labelBold
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.pICMS"
          :precision="4"
        />
      </b-col>
      <b-col sm="4">
        <InputMoney
          ref="vICMS"
          id="vICMS"
          label="Valor ICMS"
          inputClass="form-control input"
          labelBold
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.vICMS"
          :precision="2"
        />
      </b-col>
      <b-col sm="4">
        <InputMoney
          ref="vBC"
          id="vBC"
          label="Valor Base ICMS"
          inputClass="form-control input"
          labelBold
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.vBC"
          :precision="2"
        />
      </b-col>
    </b-row>
    <b-row class="row-padding">
      <b-col sm="3">
        <InputQuantity
          ref="pIPI"
          id="pIPI"
          label="% IPI"
          inputClass="form-control input"
          labelBold
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.pIPI"
          :precision="4"
        />
      </b-col>
      <b-col sm="3">
        <InputMoney
          ref="vIPI"
          id="vIPI"
          label="Valor IPI:"
          inputClass="form-control input"
          labelBold
          :precision="2"
          :disabled="
            !hasSelectedTax(productOfPurchaseOnFiscalEdit.fiscal.values.cstIpi)
          "
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.vIPI"
        />
      </b-col>
      <b-col sm="3">
        <SelectWithSearch
          label="CST IPI"
          placeholder="CST IPI"
          labelBusca="codigo"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.cstIpi"
          ref="searchCst"
          :filterBy="taxFilter"
          :change="changeCstIpiSelected"
          :options="cstIPICollection"
          :search="searchCstIpi"
        >
          <template slot="options" slot-scope="props">
            <div class="selected">
              {{ props.data.codigo }} - {{ props.data.descricao }}
            </div>
          </template>
          <template slot="no-options"> Selecione um CST IPI </template>
          <template slot="selected" slot-scope="props">
            <div class="selected">
              {{ props.data.codigo }}
            </div>
          </template>
        </SelectWithSearch>
      </b-col>
      <b-col sm="3">
        <SelectWithSearch
          label="CENQ"
          placeholder="CENQ"
          labelBusca="codigo"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.cenq"
          ref="searchCENQ"
          :filterBy="taxFilter"
          :change="changeCenqSelected"
          :options="cenqCollection"
          :search="searchCenq"
        >
          <template slot="options" slot-scope="props">
            <div class="selected">
              {{ props.data.codigo }} - {{ props.data.descricao }}
            </div>
          </template>
          <template slot="no-options"> Selecione um CENQ </template>
          <template slot="selected" slot-scope="props">
            <div class="selected">
              {{ props.data.codigo }}
            </div>
          </template>
        </SelectWithSearch>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { SelectWithSearch, InputMoney, InputQuantity } from '@/components/Form';

export default {
  name: 'TaxTab',
  components: {
    SelectWithSearch,
    InputMoney,
    InputQuantity,
  },
  data() {
    return {
      taxFilter(option, search) {
        const temp = search.toLocaleLowerCase();
        return option.descricao.includes(temp) || option.codigo.includes(temp);
      },
    };
  },
  computed: {
    ...mapState('cst', ['cstIPICollection']),
    ...mapState('cenq', ['cenqCollection']),
    ...mapState('purchase', [
      'taxInformation',
      'supplierInformation',
      'productOfPurchaseOnFiscalEdit',
    ]),
  },
  methods: {
    ...mapActions('cst', ['setCSTIPICollection']),
    ...mapActions('cenq', ['setCENQCollection']),
    ...mapActions('componentsPurchase', ['setLoadingTabPurchase']),
    hasSelectedTax(tax) {
      return !(!tax || Array.isArray(tax));
    },
    async searchCstIpi(search = null) {
      if (search) {
        this.setLoadingTabPurchase(true);
        await this.setCSTIPICollection(search);
        this.setLoadingTabPurchase(false);
      }
    },
    changeCstIpiSelected(selectedCstIpi) {
      if (selectedCstIpi) {
        this.productOfPurchaseOnFiscalEdit.fiscal.values.cstIpi = {
          ...selectedCstIpi,
        };

        return;
      }

      this.productOfPurchaseOnFiscalEdit.fiscal.values.cstIpi = [];
    },
    async searchCenq(search = null) {
      if (search) {
        this.setLoadingTabPurchase(true);
        await this.setCENQCollection(search);
        this.setLoadingTabPurchase(false);
      }
    },
    changeCenqSelected(selectedCenq) {
      if (selectedCenq) {
        this.productOfPurchaseOnFiscalEdit.fiscal.values.cenq = {
          ...selectedCenq,
        };

        return;
      }

      this.productOfPurchaseOnFiscalEdit.fiscal.values.cenq = [];
    },
  },
};
</script>
